import { ArrowBackIcon } from "@chakra-ui/icons";
import { Box, Button, Heading, HStack, Spinner } from "@chakra-ui/react";
import GenericForm from "components/BuilderForm/GenericForm";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import useApi from "hooks/useApi";
import toast from "react-hot-toast";
import { updateSubscription, getFormData } from "./apiService";
import { useQueryParams } from "utils/common";

const SubscriptionForm = () => {
  const initialFormData = {
    features: [],
    end_date: "",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const { apiCall, loading } = useApi();
  const { propertyId } = useQueryParams();
  const history = useHistory();

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const getFormDataFn = async () => {
    try {
      const response = await getFormData({
        apiCall,
        subscription_id: propertyId,
      });
      setFormData({ ...response });
    } catch (error) {
      console.log("Error fetching property data", error);
    }
  };

  useEffect(() => {
    if (propertyId) {
      getFormDataFn();
    }
  }, [propertyId]);

  const handleFormSubmit = async () => {
    try {
      const payload = { ...formData, subscription_id: propertyId };
      const response = await updateSubscription({ apiCall, payload });
      if (response) {
        setFormData(initialFormData);
        history.push("/admin/subscriptions");
      }
    } catch (error) {
      console.error("Error submitting plan:", error);
      toast.error(
        error.message || "An error occurred while submitting the plan."
      );
    }
  };

  return (
    <Box
      p={4}
      px={{ base: 4, md: 8 }}
      maxW={{ base: "100%", md: "992px" }}
      mx="auto"
    >
      <Box onClick={() => history.goBack()} style={{ cursor: "pointer" }} position={{ base: 'fixed', md: 'relative'}} zIndex={100000}     bgColor={'white'} rounded={'full'} py={3} px={4} top={2} left={2} w={'fit-content'}>
        <ArrowBackIcon height={8} width={8} />
      </Box>
      {loading && <Spinner size="lg" />}
      <Box textAlign="center" mt={{base:10, md: 0}} mb={6}>
        <Heading fontSize={30}>Update Subscription</Heading>
      </Box>
      <GenericForm
        formType="subscription"
        formData={formData}
        onChange={handleFormChange}
        errors={errors}
        setErrors={setErrors}
      />
      <HStack mt={4} justifyContent="center" alignItems="center" spacing={4}>
        <Button
          colorScheme="teal"
          size="lg"
          px={8}
          py={6}
          fontSize="lg"
          bg="purple.500"
          borderRadius="5px"
          borderColor="#637381"
          background={"linear-gradient(180deg, #22ACEE 0%, #0177B4 100%)"}
          color="#ffffff"
          onClick={handleFormSubmit}
          disabled={loading}
        >
          Submit
        </Button>
      </HStack>
    </Box>
  );
};

export default SubscriptionForm;
